import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';

export async function fetchCurrentIdToken() {
  try {
    const session = await fetchAuthSession();
    return session?.tokens?.idToken?.toString() ?? '';
  } catch {
    return '';
  }
}

export function redirectToLogIn(redirectPath = '') {
  let path = redirectPath;

  if (window.location.pathname && !path) {
    path = window.location.pathname;
    if (window.location.search) {
      path += window.location.search;
    }
  }

  const provider = import.meta.env.VITE_SAML_PROVIDER || 'keycloak';
  signInWithRedirect({ provider: { custom: provider }, customState: path || '/' });
}
